<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import mx_config from '@/plans/MASTER_CLASS/mixin';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';

export default {
  mixins: [mixin, mx_config],
  name: 'MasterclassCart',
  methods: {
    mx_license(num) {
      return (
        <div class="opc-cart-item__text">
          {num} {getPlanUnitWithQuantity(planUnitMap.membership)}
        </div>
      );
    },
    mx_cycle() {
      return <div class="opc-cart-item__text text-capitalize">
        <span>{this.$t('billing.partner.masterclass.cart_cycle_desc', [this.planCycleValue])}</span>
        <zm-tooltip
          class="opc-cart-item__license-tooltips"
          aria-label="Learn more about masterclass"
          content={this.$t('billing.partner.masterclass.unit_tips')}
          placement="bottom">
          <i class="zm-icon-info-outline" role="button"/>
        </zm-tooltip>
      </div>;
    },
    mx_discount(planCode) {
      const { discountPlans } = this.discountWithAmountMap;
      const discount = discountPlans[planCode]?.discountAmount ?? 0;

      if (!discount) return;

      return (
        <div class="opc-cart-item__discount __PLACEHOLDER_discount_title__">
          <span>{this.$t('billing.partner.exclusive_discount.subtitle')}</span>
          <span class="opc-cart-item__value text-no-capitalize">{this.$money(discount)}</span>
        </div>
      );
    },
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            const title = this.$t('billing.partner.masterclass.cart_title');

            return (
              <div>
                {this.mx_title(this.rebrandMasterClassNames(title), this.mx_price(plan), plan?.plan_code)}
                {this.mx_discount(plan.plan_code)}
                {this.mx_license(plan.cartInfo.selected_number)}
                {this.mx_cycle(plan.billing_cycle)}
                {this.mx_edit(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>

<style lang="scss">
.opc-cart-item {
  &__license-tooltips {
    color: #0B5CFF;
    margin-left: 4px;
    font-size: 16px;
    cursor: pointer;
    transform: translateY(-1px);
  }
}
</style>
